var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appBorders } from '@backrs_ui/common-ui/src/assets/appBorders';
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { BackrsIcon } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';
import { TextWithEmbeddedButton } from '@backrs_ui/common-ui/src/atoms/TextWithEmbeddedButton';
import { BackrsForm } from '@backrs_ui/common-ui/src/molecules/BackrsForm/BackrsForm';
import { Box, Typography, ButtonBase } from '@mui/material';
import { useForm } from 'react-hook-form';
import { ForgotPasswordPopup } from '../BackrsForm/ForgotPasswordPopup';
var LOGIN_STRINGS = appStrings.modules.login;
var defaultLoginValues = {
    phone: '',
    email: '',
    password: '',
};
export function LoginPage(_a) {
    var title = _a.title, handleLoggingIn = _a.handleLoggingIn, handleSigningUp = _a.handleSigningUp, errorMessage = _a.errorMessage, customAction = _a.customAction, environmentUrl = _a.environmentUrl;
    var _b = useState(false), isPasswordVisible = _b[0], setIsPasswordVisible = _b[1];
    var _c = useState(false), isForgotPasswordOpen = _c[0], setIsForgotPasswordOpen = _c[1];
    var methods = useForm({
        defaultValues: defaultLoginValues,
        resolver: function (values) {
            var errors = {};
            if (!values.phone && !values.email) {
                errors.phone = LOGIN_STRINGS.error.phoneEmailRequired;
            }
            if (values.phone && !/^\d{10}$/.test(values.phone)) {
                errors.phone = LOGIN_STRINGS.error.invalidPhone;
            }
            if (values.email && !/^\S+@\S+$/.test(values.email)) {
                errors.email = LOGIN_STRINGS.error.invalidEmail;
            }
            if (values.email && !values.password && !values.phone) {
                errors.password = LOGIN_STRINGS.error.passwordRequired;
            }
            return { values: values, errors: errors };
        },
    });
    var phoneValue = methods.watch('phone');
    var emailValue = methods.watch('email');
    var passwordValue = methods.watch('password');
    var fields = [
        {
            id: 'phone',
            name: 'phone',
            placeholder: LOGIN_STRINGS.phonePlaceholder,
            type: 'tel',
            autoComplete: 'phone',
            autoFocus: true,
            icon: {
                type: 'LEFT_ICON',
                leftIcon: 'Phone',
                leftIconColor: appColors.color.navy2,
            },
            disabled: !!emailValue && !!passwordValue,
        },
        {
            id: 'email',
            name: 'email',
            placeholder: LOGIN_STRINGS.emailPlaceholder,
            type: 'text',
            autoComplete: 'email',
            icon: {
                type: 'LEFT_ICON',
                leftIcon: 'Email',
            },
            rules: {
                required: !phoneValue ? LOGIN_STRINGS.error.emailRequired : false,
            },
            disabled: !!phoneValue,
            divider: true,
        },
        {
            id: 'password',
            name: 'password',
            placeholder: LOGIN_STRINGS.passwordPlaceholder,
            type: isPasswordVisible ? 'text' : 'password',
            autoComplete: 'current-password',
            icon: {
                type: 'BOTH_ICON',
                leftIcon: 'Lock',
                rightIcon: 'Visibility',
                rightIconColor: appColors.neutral.lightGray,
                onRightIconClick: function () { return setIsPasswordVisible(function (prev) { return !prev; }); },
            },
            disabled: !!phoneValue,
        },
    ];
    var handleSubmission = function (data) {
        handleLoggingIn(data.phone, data.email, data.password);
    };
    return (_jsxs(Box, { sx: containerStyle, children: [_jsx(BackrsIcon, { name: "BackrsWithText", alt: LOGIN_STRINGS.backrsLogoAlt, style: responsiveBackrsLogoStyle }), _jsxs(Box, { sx: loginFormStyle, children: [_jsx(Typography, { variant: "h4", fontWeight: "bold", color: appColors.color.navy3, mb: 3, children: title }), handleSigningUp && (_jsx(TextWithEmbeddedButton, { text: LOGIN_STRINGS.getStartedPrompt, buttonText: LOGIN_STRINGS.getStartedButton, onClick: handleSigningUp, sx: { mb: { xs: 3, sm: 8 } } })), _jsx(BackrsForm, { fields: fields, methods: methods, onSubmit: handleSubmission, buttonLabel: appStrings.buttonText.letsGo, children: _jsx(ButtonBase, { sx: forgotPasswordContainerStyle, onClick: function () { return setIsForgotPasswordOpen(true); }, disableRipple: true, children: _jsx(Typography, { sx: forgotPasswordStyle, children: LOGIN_STRINGS.forgotPassword }) }) }), _jsx(ForgotPasswordPopup, { isOpen: isForgotPasswordOpen, setIsOpen: setIsForgotPasswordOpen, environmentUrl: environmentUrl }), customAction && (_jsx(TextWithEmbeddedButton, { text: '', buttonText: customAction.text, onClick: customAction.onClick, sx: { mt: 2 } })), errorMessage && (_jsx(Box, { mt: 2, color: appColors.color.red1, children: errorMessage }))] })] }));
}
var containerStyle = {
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    justifySelf: 'center',
    px: 4,
    pt: 2,
    height: '100svh',
};
var loginFormStyle = __assign({ backgroundColor: appColors.neutral.white, paddingX: 2, paddingY: 3, borderRadius: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '100%', width: '100%', boxSizing: 'border-box', '@media (min-width: 300px)': {
        paddingX: 2,
        paddingY: 4,
    }, '@media (min-width: 600px)': {
        maxWidth: '500px',
        paddingX: 11,
        paddingY: 8,
    } }, appBorders.backrsDropShadowBorders.black);
var responsiveBackrsLogoStyle = {
    width: '100%',
    maxWidth: '175px',
    padding: '8px',
    marginBottom: '32px',
};
var forgotPasswordContainerStyle = {
    display: 'block',
    ml: 'auto',
    mr: 1,
};
var forgotPasswordStyle = {
    color: appColors.color.navy2,
    fontSize: '0.8125rem',
    fontWeight: 700,
};
